import ShellQuote from 'shell-quote';
class ConsoleUtils {
  static hasComment(arg) {
    return arg.comment !== undefined;
  }
  static hasPattern(arg) {
    return arg.pattern !== undefined;
  }
  static hasOp(arg) {
    return arg.op !== undefined;
  }

  /**
   * Given the provided text, parse out arguments using shell quoting rules.
   * @param str The text to parse.
   * @returns string[] of the arguments. Empty if no arguments found.
   */
  static parseArguments(str) {
    if (str == null || !(typeof str === 'string' || str instanceof String)) {
      return [];
    }

    // Parse can return an object, not just a string. See the `ParseEntry` type def for all types
    // We must map them all to strings. Filter out comments that will not be needed as well.
    return ShellQuote.parse(str).filter(arg => !this.hasComment(arg)).map(arg => {
      if (this.hasPattern(arg)) {
        return arg.pattern;
      }
      if (this.hasOp(arg)) {
        return arg.op;
      }
      return "".concat(arg);
    });
  }
  static formatTimestamp(date) {
    if (date == null || !(date instanceof Date)) {
      return null;
    }
    var hours = "".concat(date.getHours()).padStart(2, '0');
    var minutes = "".concat(date.getMinutes()).padStart(2, '0');
    var seconds = "".concat(date.getSeconds()).padStart(2, '0');
    var milliseconds = "".concat(date.getMilliseconds()).padStart(3, '0');
    return "".concat(hours, ":").concat(minutes, ":").concat(seconds, ".").concat(milliseconds);
  }
  static isTableType(dh, type) {
    return type === dh.VariableType.TABLE || type === dh.VariableType.TREETABLE || type === dh.VariableType.HIERARCHICALTABLE || type === dh.VariableType.PARTITIONEDTABLE;
  }
  static isWidgetType(dh, type) {
    return type === dh.VariableType.FIGURE || type === dh.VariableType.OTHERWIDGET || type === dh.VariableType.PANDAS;
  }
  static isOpenableType(dh, type) {
    return ConsoleUtils.isTableType(dh, type) || ConsoleUtils.isWidgetType(dh, type);
  }
  static isFigureType(dh, type) {
    return type === dh.VariableType.FIGURE;
  }
  static isPandas(dh, type) {
    return type === dh.VariableType.PANDAS;
  }
}
export default ConsoleUtils;
//# sourceMappingURL=ConsoleUtils.js.map